import { useVersionCheck } from '@/composables/useVersionCheck.ts'

export default {
  install() {
    const vc = useVersionCheck()
    vc.start()
  }
}
